import { FLOW_TYPES } from "../../constants/flowType";
import { ACTION_TYPES } from "../actionTypes";

const ticketingReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.APP_SET_DATA: {
      return {
        ...state,
        ...action.payload.data,
      };
    }
    case ACTION_TYPES.CLEAR_ERROR_MESSAGE: {
      return {
        ...state,
        appData: {
          ...state.appData,
          config: {
            ...state.appData?.config,
            texts: {
              ...state.appData?.config?.texts,
              error_message: "",
            },
          },
        },
      };
    }
    case ACTION_TYPES.SET_ADMISSION_TICKETS: {
      if (action?.payload?.qty >= 0) {
        let newItem;
        const newState = state;
        const newSummaryAdmissionTickets = [
          ...state.summary.selectedAdmissionTickets,
        ];
        // check index if selected id is in summary
        const indexOfTicket = newSummaryAdmissionTickets.findIndex(
          (ticket) => ticket.id === action.payload.id
        );
        const ordinalOfTicket = state.admission_tickets.findIndex(
          (admission_ticket) => admission_ticket.id === action.payload.id
        );
        const existingQty =
          newState.summary.selectedAdmissionTickets[indexOfTicket]?.qty;
        const isAddingNewTicket = Boolean(
          existingQty === undefined && action.payload.qty > 0
        );
        const isChangingQty = Boolean(
          existingQty !== undefined && existingQty !== action.payload.qty
        );

        // If quantity changes reset all dependant data
        if (isAddingNewTicket || isChangingQty) {
          newState.dates = [];
          newState.summary = {
            ...newState.summary,
            selectedDate: null,
            selectedAddonTickets: {},
            selectedTimeslot: null,
          };
        }

        // if exists in summary remove it
        if (indexOfTicket > -1) {
          newSummaryAdmissionTickets.splice(indexOfTicket, 1);
        }
        if (action.payload.qty > 0) {
          newItem = {
            id: action.payload.id,
            productSku: action.payload.productSku,
            qty: action.payload.qty,
            admission: action.payload.admission,
            ordinal: ordinalOfTicket,
            ticketType: action.payload.ticketType,
          };
          newSummaryAdmissionTickets.splice(indexOfTicket, 0, newItem);
        }
        return {
          ...newState,
          summary: {
            ...newState.summary,
            selectedAdmissionTickets: [...newSummaryAdmissionTickets],
          },
        };
      }
      return state;
    }

    case ACTION_TYPES.SET_ADDON_TICKETS: {
      const { addonId, qty, entry_no, price, selectedDate } = action.payload;
      let selectedAddonTicketsTemp = { ...state.summary.selectedAddonTickets };
      selectedAddonTicketsTemp = {
        ...selectedAddonTicketsTemp,
        [addonId]: {
          entry_no,
          qty,
          price,
          selectedDate,
        },
      };
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedAddonTickets: { ...selectedAddonTicketsTemp },
        },
      };
    }

    case ACTION_TYPES.REMOVE_ADDON_TICKET_TIMESLOT: {
      const { addonId } = action.payload;
      const selectedAddonTicketsTemp = {
        ...state.summary.selectedAddonTickets,
      };
      if (selectedAddonTicketsTemp.hasOwnProperty(addonId)) {
        delete selectedAddonTicketsTemp[addonId];
      }
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedAddonTickets: { ...selectedAddonTicketsTemp },
        },
      };
    }
    case ACTION_TYPES.RESET_SUMMARY_ADDON_TICKETS: {
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedAddonTickets: {},
        },
      };
    }
    case ACTION_TYPES.SET_TOTALS: {
      return {
        ...state,
        summary: {
          ...state.summary,
          totals: { ...action.payload.totals },
        },
      };
    }

    case ACTION_TYPES.SET_ACTIVE_STEP: {
      const { stepToSet } = action.payload;
      const stepsTotal = Object.keys(state.stepper.steps).length;
      if (stepToSet < 0 || stepToSet > stepsTotal) {
        return state;
      }

      return {
        ...state,
        stepper: {
          ...state.stepper,
          active: stepToSet,
          steps: {
            ...state.stepper.steps,
            [stepToSet]: {
              ...state.stepper.steps[stepToSet],
              isVisited: true,
            },
          },
        },
      };
    }

    case ACTION_TYPES.SET_STEP_IS_VALID: {
      const { step, isValid } = action.payload;
      const stepsTotalCount = Object.keys(state.stepper.steps).length;
      if (step > stepsTotalCount - 1) {
        return state;
      }

      return {
        ...state,
        stepper: {
          ...state.stepper,
          steps: {
            ...state.stepper.steps,
            [step]: {
              ...state.stepper.steps[step],
              isValid,
            },
          },
        },
      };
    }

    case ACTION_TYPES.SET_WARNINGS: {
      if (!action.payload.warnings) {
        return state;
      }
      return {
        ...state,
        warnings: {
          ...action.payload.warnings,
        },
      };
    }

    case ACTION_TYPES.SET_SELECTED_DATE: {
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedDate: action.payload.selectedDate,
          selectedDateIndex: action.payload.selectedDateIndex,
          selectedTimeslot: null,
        },
      };
    }
    case ACTION_TYPES.SET_SELECTED_TIMESLOT: {
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedTimeslot: action.payload.selectedTimeslot,
        },
      };
    }
    case ACTION_TYPES.SET_SELECTED_CURRENCY: {
      return {
        ...state,
        selectedCurrency: action.payload.selectedCurrency.name,
        currency: action.payload.selectedCurrency.name,
        summary: {
          ...state.summary,
          selectedCurrency: action.payload.selectedCurrency,
        },
      };
    }
    case ACTION_TYPES.SET_CODE: {
      const { type, value, isValid } = action.payload;
      return {
        ...state,
        codes: {
          ...state.codes,
          [type]: { value, isValid },
        },
      };
    }
    case ACTION_TYPES.RESTORE_ADDONS: {
      const selectedAddons = { ...state.selectedAddons };

      const selectedDate = state.summary.selectedDate;

      state.summary.restoredAddons.forEach((restoredAddon) => {
        const addon = state.addons.find(
          (addon) => addon.admission_code === restoredAddon.admission
        );
        const isSpecialEvent =
          addon?.admission_code?.toUpperCase()?.replace(" ", "") !==
            "BEERTASTING" &&
          addon?.admission_code?.toUpperCase()?.replace(" ", "") !==
            "GUIDEDTOUR";

        let price;
        if (state.flowType === FLOW_TYPES.ACTIVITIES_ONLY) {
          price = addon?.dates?.[0]?.timeslots?.[0]?.price;
        } else {
          price = addon?.dates
            .find((date) => date.date === selectedDate)
            ?.timeslots.find(
              (timeslot) =>
                timeslot.entry_no === restoredAddon.entry_no.toString()
            )?.price;
        }
        if (price || (isSpecialEvent && addon)) {
          selectedAddons[addon.id] = {
            entry_no: restoredAddon.entry_no,
            price,
            qty: restoredAddon.qty,
          };
        }
      });

      return {
        ...state,
        summary: {
          ...state.summary,
          restoredAddons: [],
          selectedAddonTickets: selectedAddons,
        },
      };
    }
    case ACTION_TYPES.UPDATE_CART: {
      return {
        ...state,
        cart: action.payload,
      };
    }
    case ACTION_TYPES.RESTORE_CART: {
      const selectedAdmissionTickets = [];
      const restoredAddons = [];
      let selectedDate = null;
      let selectedTimeslot = null;
      let goToStep = 0;
      const restoredGiftCardVariants = {};

      // Safely parse Copenhagen Card data
      let parsedCCCardData = null;
      try {
        const copenhagenCardData = sessionStorage.getItem(
          "copenhagen_card_data"
        );
        if (copenhagenCardData) {
          parsedCCCardData = JSON.parse(copenhagenCardData);
        }
      } catch (error) {
        console.error("Failed to parse Copenhagen Card data:", error);
      }

      const shouldSkipCartUpdate = !parsedCCCardData && state.is_city_card;

      const getAttributeValue = (attributes, key) => {
        if (!Array.isArray(attributes)) {
          return null;
        }
        const attr = attributes.find((a) => a.key === key);
        return attr?.value;
      };

      action.payload.data.cart.lines.forEach((restoredTicket) => {
        const attributes = restoredTicket.attributes;
        const admissionCode = getAttributeValue(attributes, "_admission_code");
        const scheduleNumber = getAttributeValue(
          attributes,
          "_schedule_number"
        );
        const scheduleStartDate = getAttributeValue(
          attributes,
          "_schedule_start_date"
        );

        if (
          state.flowType === FLOW_TYPES.GIFT_CARD &&
          !admissionCode &&
          !scheduleNumber
        ) {
          const variantId = restoredTicket.merchandise?.id;
          if (variantId) {
            const priceAmount = Number(
              restoredTicket.merchandise?.price?.amount || 0
            );
            restoredGiftCardVariants[variantId] = {
              id: variantId,
              title: String(Math.round(priceAmount)),
              price: restoredTicket.merchandise?.price,
              qty: restoredTicket.quantity,
              lineId: restoredTicket.id,
            };
          }
          return;
        }

        const admissionTicket = state.admission_tickets.find(
          (ticket) => ticket.id === restoredTicket.merchandise.product.id
        );

        if (admissionTicket !== null && admissionTicket !== undefined) {
          selectedAdmissionTickets.push({
            admission: admissionTicket.admission,
            id: admissionTicket.id,
            productSku: admissionTicket.product_sku,
            qty: restoredTicket.quantity,
          });

          const requiredAdmissions = admissionTicket?.admission?.filter(
            (admission) =>
              admission.selection_type === "required" &&
              admission.code !== "REWARDBEER" &&
              admission.code !== "REWARDSODA"
          );
          if (
            requiredAdmissions?.length > 0 &&
            admissionCode === "VISITCARLSBERG"
          ) {
            if (!selectedDate && scheduleStartDate) {
              const cartDate = new Date(scheduleStartDate);
              const now = new Date();

              const cartDateOnly = new Date(
                cartDate.getFullYear(),
                cartDate.getMonth(),
                cartDate.getDate()
              );
              const nowDateOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
              );

              if (cartDateOnly >= nowDateOnly) {
                selectedDate = new Date(scheduleStartDate).setUTCHours(
                  0,
                  0,
                  0,
                  0
                );
              }
            }
            if (selectedDate && !selectedTimeslot && scheduleNumber) {
              selectedTimeslot = scheduleNumber.toString();
              goToStep = 2;
            }
          }
        } else if (admissionCode && scheduleNumber && restoredTicket.quantity) {
          restoredAddons.push({
            admission: admissionCode,
            entry_no: scheduleNumber.toString(),
            qty: restoredTicket.quantity,
          });
        }
      });

      if (selectedAdmissionTickets.length > 0) {
        if (selectedTimeslot) {
          goToStep = 2;
        } else {
          goToStep = 1;
        }
      }

      let selectedDateIndex = null;
      if (selectedDate && Array.isArray(state.dates)) {
        selectedDateIndex = state.dates.findIndex((dateObj) => {
          const selectedDateStr = new Date(selectedDate)
            .toISOString()
            .split("T")[0];
          const dateObjStr =
            typeof dateObj.date === "string"
              ? dateObj.date.split("T")[0]
              : new Date(dateObj.date).toISOString().split("T")[0];
          return selectedDateStr === dateObjStr;
        });
        if (selectedDateIndex === -1) {
          selectedDateIndex = null;
        }
      }

      if (shouldSkipCartUpdate) {
        return { ...state };
      }
      return {
        ...state,
        cart: action.payload.data.cart.lines,
        stepper: {
          ...state.stepper,
          active: goToStep,
        },
        summary: {
          ...state.summary,
          selectedAdmissionTickets,
          selectedDate,
          selectedDateIndex,
          selectedTimeslot,
          restoredAddons,
          selectedGiftCardVariants: restoredGiftCardVariants,
          ...(state.is_city_card && parsedCCCardData
            ? {
                CCCardsDateRange: parsedCCCardData.dateRange,
                selectedCCCards: parsedCCCardData.selectedCCCards,
              }
            : undefined),
        },
      };
    }

    case ACTION_TYPES.ADD_SELECTED_TIMESLOT: {
      const { timeSlot } = action.payload;

      const existingSlotIndex = state.selectedTimeslots.findIndex(
        (existingTimeSlot) =>
          existingTimeSlot.admission_code === timeSlot.admission_code &&
          (!existingTimeSlot.addonId ||
            existingTimeSlot.addonId === timeSlot.addonId)
      );

      let updatedSelectedTimeslots;

      if (existingSlotIndex !== -1) {
        updatedSelectedTimeslots = [...state.selectedTimeslots];
        updatedSelectedTimeslots[existingSlotIndex] = timeSlot;
      } else {
        updatedSelectedTimeslots = [...state.selectedTimeslots, timeSlot];
      }

      return {
        ...state,
        selectedTimeslots: updatedSelectedTimeslots,
      };
    }

    case ACTION_TYPES.REMOVE_SELECTED_TIMESLOT: {
      const timeSlotToRemove = action.payload;

      const updatedSelectedTimeslots = state.selectedTimeslots.filter(
        (existingTimeSlot) =>
          existingTimeSlot.start_time !== timeSlotToRemove.start_time ||
          existingTimeSlot.end_time !== timeSlotToRemove.end_time
      );

      return {
        ...state,
        selectedTimeslots: updatedSelectedTimeslots,
      };
    }
    case ACTION_TYPES.CLEAR_SELECTED_TIMESLOTS: {
      return {
        ...state,
        selectedTimeslots: [],
      };
    }
    case ACTION_TYPES.SET_CC_CARDS: {
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedCCCards: action.payload.cards,
          CCCardsDateRange: {
            startDate: action.payload.dateRange[0],
            endDate: action.payload.dateRange[1],
          },
        },
      };
    }
    case ACTION_TYPES.RESET_SUMMARY_ADMISSION_TICKETS: {
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedAdmissionTickets: [],
        },
      };
    }
    case ACTION_TYPES.SET_LOGIN_SESSION_DATA: {
      return {
        ...state,
        loginSessionData: action.payload.data,
      };
    }

    case ACTION_TYPES.REMOVE_GIFT_CARD_VARIANT: {
      const variantId = action.payload?.variantId;
      if (!variantId || !state.summary?.selectedGiftCardVariants?.[variantId]) {
        return state;
      }
      const next = { ...state.summary.selectedGiftCardVariants };
      delete next[variantId];
      return {
        ...state,
        summary: {
          ...state.summary,
          selectedGiftCardVariants: next,
        },
      };
    }

    default:
      return state;
  }
};

export { ticketingReducer };
